var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGermany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4960_4815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 16.0434C2.69552 20.613 7.09403 23.8695 12.2536 23.8695C17.4132 23.8695 21.8117 20.613 23.5072 16.0434L12.2536 15L1 16.0434Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2536 0C7.09403 0 2.69552 3.2565 1 7.82611L12.2536 8.86955L23.5072 7.82606C21.8117 3.2565 17.4132 0 12.2536 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.746391 8C0.264047 9.29998 0 10.706 0 12.1739C0 13.6417 0.264047 15.0478 0.746391 16.3478H23.2537C23.736 15.0478 24 13.6417 24 12.1739C24 10.706 23.736 9.29998 23.2536 8H0.746391Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4960_4815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/germany.359e9ecb47ced42e957e4f6ff560f166.svg";
export { ForwardRef as ReactComponent };